import { Eye, FileDown, Mail, Save } from "lucide-react";
import { btn } from "@/components/common/btn";

const ACTIVE = ["draft", "submitted", "approved", "on_hand", "scheduled", "in_progress", "en_route", "on_site"];
const EMAIL_TESTID = { draft: "btn-email-wo", submitted: "btn-resend-email", approved: "btn-email-approved", on_hand: "btn-email-approved" };

// Save · View · PDF · Email — top-left of the Line items tab (moved out of the header card).
export function WOLineItemsActions({ form, handleSave, setShowWOPreview, handleDownloadPDF, openEmailDialog }) {
  const status = form.status || "draft";
  const isActive = ACTIVE.includes(status);
  const emailMode = ["scheduled", "in_progress", "en_route", "on_site"].includes(status) ? "signed" : "submit";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="wo-line-items-actions">
      {isActive && (
        <button type="button" className={btn("write")} onClick={() => handleSave()} title="Save" data-testid="btn-save-wo">
          <Save className="w-3.5 h-3.5" />
        </button>
      )}
      <button type="button" className={btn("nav")} onClick={() => setShowWOPreview(true)} title="View" data-testid="btn-view-wo">
        <Eye className="w-3.5 h-3.5" />
      </button>
      <button type="button" className={btn("nav")} onClick={handleDownloadPDF} data-testid="btn-download-pdf">
        <FileDown className="w-3.5 h-3.5" /> PDF
      </button>
      {isActive && (
        <button type="button" className={btn("data")} onClick={() => openEmailDialog(emailMode)}
          data-testid={emailMode === "signed" ? "btn-resend-signed" : (EMAIL_TESTID[status] || "btn-email-wo")}>
          <Mail className="w-3.5 h-3.5" /> {emailMode === "signed" ? "Signed WO" : "WO"}
        </button>
      )}
    </div>
  );
}
